import type { ReactNode } from 'react'
import { Box, Group, Text } from '@grovus/design-system'
import type { RequestCopy } from '../i18n'

/** "7 October" in local time, the date of screen 5's "Request sent on" line. */
export function formatDay(iso: string, copy: RequestCopy): string {
  const d = new Date(iso)
  return `${d.getDate()} ${copy.months[d.getMonth()]}`
}

/** A failure the person has to see, in the sign-in screen's alert colours. */
export function Alert({ children }: { children: ReactNode }) {
  return (
    <Box
      role="alert"
      mt="md"
      p="sm"
      style={{
        border: '1px solid light-dark(var(--mantine-color-bad-3), var(--mantine-color-bad-8))',
        borderRadius: 8,
        background: 'light-dark(var(--mantine-color-bad-0), var(--mantine-color-bad-9))',
      }}
    >
      <Text fz="sm" style={{ color: 'light-dark(var(--mantine-color-bad-7), var(--mantine-color-bad-3))' }}>
        {children}
      </Text>
    </Box>
  )
}

/** The optional "What will you use Grovus for?" field; the design system has no textarea. */
export function MessageField({ id, label, copy, value, onChange, disabled }: {
  id: string
  label: string
  copy: RequestCopy
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}) {
  return (
    <Box mt="md">
      <Group justify="space-between" mb={4}>
        <Text component="label" htmlFor={id} fz="sm" fw={500}>{label}</Text>
        <Text fz="xs" className="grv-muted">{copy.optional}</Text>
      </Group>
      <textarea
        id={id}
        rows={4}
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        style={{
          display: 'block', width: '100%', resize: 'vertical', padding: '8px 12px',
          font: 'inherit', fontSize: 'var(--mantine-font-size-md)', color: 'var(--mantine-color-text)',
          background: 'var(--mantine-color-body)', border: '1px solid var(--mantine-color-default-border)',
          borderRadius: 'var(--mantine-radius-md)',
        }}
      />
    </Box>
  )
}
